export default [
	{
		title: 'Dashboards',
		icon: 'HomeIcon',
		/*
                                                                             tag: '2',
                                                                             tagVariant: 'light-warning', */

		route: 'dashboard',
		/* children: [
      /!*{
        title: 'eCommerce',
        route: 'dashboard-ecommerce',
      },*!/
      {
        title: 'Analytics',
        route: 'dashboard-analytics',
      },
    ], */
	},
	{
		header: 'Transaksi',
	},
	{
		title: 'Order',
		icon: 'DollarSignIcon',
		route: 'order',
	},
	{
		title: 'Produk',
		route: 'apps-produk-list',
		icon: 'PackageIcon',
	},
	{
		title: 'Stock',
		route: 'stock',
		icon: 'ArchiveIcon',
	},
	{
		title: 'Customers',
		route: 'apps-customers-list',
		icon: 'UsersIcon',
	},
	{
		title: 'Penerimaan',
		route: 'apps-penerimaan-list',
		icon: 'BoxIcon',
	},
	{
		title: 'Retur Penerimaan',
		route: 'apps-returpenerimaan-list',
		icon: 'PackageIcon',
	},
	{
		title: 'QC Reject',
		route: 'apps-qc-reject-list',
		icon: 'AlertTriangleIcon',
	},
	{
		title: 'Discount',
		route: 'apps-discount',
		icon: 'PercentIcon',
	},
	{
		title: 'Invoice',
		icon: 'FileTextIcon',
		route: 'apps-invoice-list',
		children: [
			{
				title: 'List',
				route: 'apps-invoice-list',
			},
			{
				title: 'Preview',
				hidden: 'true',
				route: { name: 'apps-invoice-preview', params: { id: 4987 } },
			},
		],
	},
	{
		title: 'Bank Confirmation',
		icon: 'CreditCardIcon',
		route: 'apps-invoice-bankconfirm-list',
	},
]
